import { ChainMap, ChainMetadata } from "@hyperlane-xyz/sdk";
import { ProtocolType } from "@hyperlane-xyz/utils";

// A map of chain names to ChainMetadata
// Chains can be defined here, in chains.json, or in chains.yaml
// Chains already in the SDK need not be included here unless you want to override some fields
// Schema here: https://github.com/hyperlane-xyz/hyperlane-monorepo/blob/main/typescript/sdk/src/metadata/chainMetadataTypes.ts
//
// RPC overrides: the registry's published metadata uses Ankr as the primary
// RPC for several chains (notably bsc). `mergeChainMetadataMap` prepends these
// entries to the registry list, so the URL listed here is tried first. Entries
// must be full ChainMetadata records because they're validated against the
// ChainMetadataSchema before merging — additional fields from the registry
// (explorers, gas token, etc.) are preserved via object merge.
const evm = (name: string, chainId: number, rpc: string): ChainMetadata => ({
  protocol: ProtocolType.Ethereum,
  name,
  chainId,
  domainId: chainId,
  rpcUrls: [{ http: rpc }],
});

export const chains: ChainMap<ChainMetadata & { mailbox?: Address }> = {
  bsc: evm("bsc", 56, "https://bsc-rpc.publicnode.com"),
  ethereum: evm("ethereum", 1, "https://ethereum-rpc.publicnode.com"),
  arbitrum: evm("arbitrum", 42161, "https://arbitrum-one-rpc.publicnode.com"),
  optimism: evm("optimism", 10, "https://optimism-rpc.publicnode.com"),
  polygon: evm("polygon", 137, "https://polygon-bor-rpc.publicnode.com"),
  prom: evm("prom", 227, "https://rpc.prom.io"),
};
